/* eslint-disable */

import { Route, Switch, useRouteMatch } from 'react-router';
import VariantBatchSizePage from '../../../Pages/Food Products/VariantBatchSize/VariantBatchSizePage';

// const getSubURL = (entity) => {
// 	const baseEntity = urls.FOOD_PRODUCTS;
// 	return entity.slice(baseEntity.length);
// };

const VariantBatchSizeRoutes = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<Route exact path={`${path}`}>
				<VariantBatchSizePage />
			</Route>
		</Switch>
	);
};

export default VariantBatchSizeRoutes;
